/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-06-02 23:17:05
 **/

import { PropsWithChildren } from "react";
import { useAtomValue } from "jotai";
import styled from "@emotion/styled";

import { EditState } from "./atom";
import { useWidget } from "@/frameworks/core/hooks";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOGTAG = "#WidgetLayout#";

type WidgetLayoutProps = unknown;

export default function WidgetLayout(props: PropsWithChildren<WidgetLayoutProps>) {
	const widgetEditState = useAtomValue(EditState);
	const { saveWidget } = useWidget();

	const handleEditConfirm = () => {
		widgetEditState && saveWidget();
	};

	return (
		<PageContainer {...props} onClick={handleEditConfirm}>
			{props.children}
		</PageContainer>
	);
}

const PageContainer = styled.div`
	display: flex;
	flex: 1;
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;
`;
